// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"28dc9cfa","684":"91eeb41d","792":"13738a69"}[chunkId] + ".chunk.css";
};